const floorFiveMinutes = function(timestamp) {
    return Math.floor(timestamp / 300) * 300;
}

module.exports = {
    floorFiveMinutes: floorFiveMinutes
}